module.exports = __webpack_public_path__ + "img/file-check-03.73ace3f8.svg";